<template>
	<div class="payment-buyer" @click="setZipCodeAndAddress4IOS">
		<h3>결제자 정보</h3>

		<div class="buyer-info gui-form">
			<!-- mobile form -->
			<form id="mobileweb" name="mobileweb" method="POST" accept-charset="EUC-KR">
				<input :type="isDev" name="P_NEXT_URL" :value="pg.siteDomain + pg.returnUrl + '?mode=MOBILE'">
				<input :type="isDev" name="P_INI_PAYMENT" :value="this.pg.payment">
				<input :type="isDev" name="P_MID" :value="pg.mid">
				<input :type="isDev" name="P_GOODS" :value="pg.oid">
				<input :type="isDev" name="P_AMT" :value="totalCost">
				<input :type="isDev" name="P_UNAME" :value="orderInfo.deliveryReceiverName">
				<input :type="isDev" name="P_OID" :value="pg.oid">
			</form>

			<!-- pc form -->
			<form id="SendPayForm_id" name="SendPayForm_id" method="POST" accept-charset="EUC-KR">
				<input :type="isDev" name="gopaymethod" :value="this.pg.payment">  <!-- 결제 수단 선택 : Card,DirectBank,HPP,Vbank,kpay,Swallet,Paypin,EasyPay,PhoneBill,GiftCard,EWallet
																					onlypoint,onlyocb,onyocbplus,onlygspt,onlygsptplus,onlyupnt,onlyupntplus -->
				<input :type="isDev" name="version" value="1.0">                   <!-- 전문버전 1.0 고정 -->
				<input :type="isDev" name="logo_url" :value="pg.siteDomain+'/ssflex/assets/img/temp/temp_logo_pg.png'">       <!-- 메인로고 삽입 [size: 89*18] -->
				<input :type="isDev" name="logo_2nd" :value="pg.siteDomain+'/ssflex/assets/img/temp/temp_logo_pg.png'">       <!-- 서브로고 삽입 [size: 64*13] -->
				<input :type="isDev" name="mid" :value="pg.mid">                   <!-- 상점아이디 -->
				<input :type="isDev" name="goodname" :value="pg.oid">              <!-- oid? -->
				<input :type="isDev" name="price" :value="totalCost">              <!-- 결제금액 (숫자만, 1달러는 100으로 시작) -->
				<!--				<input :type="isDev" name="price" :value="100">                    &lt;!&ndash; 결제금액 (숫자만, 1달러는 100으로 시작) 테스트용&ndash;&gt;-->
				<input :type="isDev" name="timestamp" :value="pg.timestamp">       <!-- 타임스템프 [TimeInMillis(Long형)] -->
				<input :type="isDev" name="signature" :value="pg.signature">       <!-- SHA256 Hash값 [대상: oid, price, timestamp] -->
				<input :type="isDev" name="mKey" :value="pg.mKey">                 <!-- SHA256 Hash값 [대상: mid 와 매칭되는 signkey]   -->
				<input :type="isDev" name="currency" value="WON">                  <!-- 통화구분 ["WON":한화,"USD":달러] -->
				<!-- <input :type="isDev" name="buyername" value="홍길동" >-->
				<!-- <input :type="isDev" name="buyertel" value="010-1234-5678" >-->       <!-- 구매자 휴대폰번호 -->
				<input :type="isDev" name="buyeremail" :value="orderInfo.email">   <!-- 구매자 이메일주소 "@", "." 외 특수문자 입력불가 -->
				<input :type="isDev" name="acceptmethod" value="below1000">
				<!--				<input :type="isDev"  name="acceptmethod" :value="'vbank('+ vBankDate +')'">-->
				<input :type="isDev" name="payViewType" value="">                  <!-- popupUrl 사용시 popup으로 반드시 설정 -->
				<input :type="isDev" name="returnUrl" :value="pg.siteDomain + pg.returnUrl + '?mode=WEB'">  <!-- 결과수신 URL -->
				<input :type="isDev" name="closeUrl" :value="pg.siteDomain + closeUrl">       <!-- 결제창 닫기 URL -->
				<!--				<input :type="isDev" name="popupUrl" :value="pg.siteDomain + popupUrl">       &lt;!&ndash; payViewType='popup'시 팝업을 띄울수 있도록 처리해주는 URL (선택) &ndash;&gt;-->
				<input :type="isDev" name="oid" :value="pg.oid">

				<div class="row-box">
					<label class="label" for="buyername">이름</label>
					<div class="inp-set">
						<input id="buyername" name="buyername" type="text" placeholder="이름" v-model="orderInfo.deliveryReceiverName">
					</div>
				</div>
				<div class="row-box">
					<label class="label" for="buyertel">전화번호</label>
					<div class="inp-set">
						<input id="buyertel" name="buyertel" type="tel" maxlength="12" placeholder="전화번호" v-model="orderInfo.deliveryReceiverPhone" @keyup="numberUtils.setOnlyNum('buyertel')" @change="checkPhone()">
					</div>
					<p v-html="infoMsg"></p>
				</div>
				<div class="row-box">
					<label class="label" for="email">이메일</label>
					<div class="inp-sel-set">
						<input id="email" class="inp-mail" name="email" type="email" placeholder="이메일 아이디" v-model="orderInfo.email" @change="checkEmail">
						<select id="email2" name="email2" v-model="email2">
							<option value="naver.com">naver.com</option>
							<option value="nate.com">nate.com</option>
							<option value="gmail.com">gmail.com</option>
							<option value="hanmail.net">hanmail.net</option>
							<option value="yahoo.com">yahoo.com</option>
							<option value="hotmail.com">hotmail.com</option>
							<option value="daum.net">daum.net</option>
							<option value="korea.kr">korea.kr</option>
							<option value="paran.com">paran.com</option>
							<option value="">직접입력</option>
						</select>
					</div>
				</div>
				<div class="row-box address">
					<label class="label" for="zipcode">주소</label>
					<div class="inp-btn-set">
						<input id="zipcode" name="zipcode" type="text" disabled v-model="orderInfo.deliveryZipcode">
						<button type="button" @click="postCode()">주소검색</button>
					</div>
					<div class="inp-set">
						<input id="address1" name="address1" type="text" placeholder="동(읍/면) 까지의 주소" disabled v-model="orderInfo.deliveryAddress1">
					</div>
					<div class="inp-set">
						<input id="address2" name="address2" type="text" placeholder="상세주소" v-model="orderInfo.deliveryAddress2">
					</div>
				</div>
			</form>
		</div>
		<p class="information">결제자의 정보로 결제와 관련된 정보가 제공됩니다. 정확하게 입력해 주세요.</p>
		<div style="margin-bottom: 18px; display: inline-flex">
			<p class="inforAgree">개인정보 수집 및 이용 동의 : (주)상상진화</p>
			<button class="inforAgreeBtn" @click="openStaticPage('/app/statics/privacypolicy')">내용보기</button>
<!--			<button class="inforAgreeBtn" type="button" data-toggle="modal" data-target="#terms1">내용보기</button>-->
		</div>

		<!--		<div style="margin: 18px 8px 18px 0px; display: inline-flex">-->
		<!--			<p class="information">이용약관 동의</p>-->
		<!--			<button type="button" data-toggle="modal" data-target="#terms1" style="margin-left: 8px">내용보기</button>-->
		<!--		</div>-->

		<div class="payment-method">
			<h3>결제방법</h3>
			<ul class="method-list" @change="changePaymnt">
				<li>
					<input type="radio" name="paymentType" id="credit-card" class="inp-radio" value="C" checked v-model="orderInfo.paidType">
					<label for="credit-card" class="lab-radio">신용카드</label>
				</li>
				<!--				<li>-->
				<!--					<input type="radio" name="paymentType" id="bank-transfer" class="inp-radio" value="B" v-model="orderInfo.paidType">-->
				<!--					<label for="bank-transfer" class="lab-radio">계좌이체</label>-->
				<!--				</li>-->
				<!--				<li>-->
				<!--					<input type="radio" name="paymentType" id="bank-deposit" class="inp-radio" value="D" v-model="orderInfo.paidType">-->
				<!--					<label for="bank-deposit" class="lab-radio">무통장 입금</label>-->
				<!--				</li>-->
			</ul>
		</div>

		<div class="btn-area">
			<button type="button" class="btn-submit" name="pay" value="결제" @click="doPurchase()">결제 진행하기</button>
		</div>

		<!--		<script type="application/javascript" src="https://stgstdpay.inicis.com/stdjs/INIStdPay.js" charset="UTF-8"></script>-->
		<!--		<script type="application/javascript" src="//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js"></script>-->
	</div>

</template>
<script>

import $ from 'jquery'
import moment from "moment";
import HWAPP from '@/commons/mixins/hwapp.mixin'

export default {
	name: "orderUser",
	mixins: [HWAPP],
	props: {
		orderInfo: Object,
		totalCost: Number,
	},
	data() {
		return {
			email1: "",
			email2: "",
			isDev: "hidden",
			pg: {},
			infoMsg: '<p class="information">예시) 01012345678</p>',
			closeUrl: "app/shop/closePg",
			// popupUrl: "shop/popupPg",
			vBankDate: new Date(),
			isIOS: false,
		}
	},
	updated() {
	},
	created() {
		// this.$loadScript("https://stgstdpay.inicis.com/stdjs/INIStdPay.js")  //TEST
		this.$loadScript("https://stdpay.inicis.com/stdjs/INIStdPay.js")
				.then(() => {
					this.getPgInfo();
				})
		this.$loadScript("//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js")
	},
	mounted() {
		this.vBankDate = moment(this.vBankDate).add(2, 'days').format("YYYYMMDD")
		console.log('vBankDate', this.vBankDate)
	},
	methods: {
		pay() {
			var myform = document.mobileweb;
			myform.action = "https://mobile.inicis.com/smart/payment/";
			myform.target = "_self";
			myform.submit();
		},
		doPurchase() {
			const self = this;

			this.axiosCaller.get(this, this.APIs.SHOP_PG + "/getIniInfo", {
				totalPrice: this.totalCost
				// totalPrice : '100'
			}, (res) => {
				var result = res.data
				if (result.status === "ok") {
					this.pg = result.pg;
					self.orderInfo.oid = self.pg.oid
					console.log('pginfo self.orderInfo.oid',self.orderInfo.oid)

					console.log('===pg====', this.pg)
					self.checkInfo()
				} else {
					this.swalUtils.gritter("Error", result.msg, "error")
							.then(() => {
								location.href = document.referrer
							})
				}
			})


		},
		checkInfo() {
			const self = this;

			//주문 상품, 결제자 정보 저장
			self.orderInfo.orderPrice = self.totalCost;
			console.log("doPurchase", self.orderInfo)

			self.orderInfo.orderPrice = self.totalCost

			if (self.orderInfo.email.indexOf("@") === -1) {
				self.orderInfo.email = self.orderInfo.email + '@' + self.email2
				console.log(self.orderInfo.email)
			} else {
				// this.orderInfo.email = this.email1
				console.log(self.orderInfo.email)
			}

			if (
					self.orderInfo.email === "" ||
					self.orderInfo.paidType === "" ||
					self.orderInfo.deliveryReceiverName === ""
			) {
				self.swalUtils.gritter('결제자 정보를 입력해 주세요.', "", "info", 1000)
			} else {
				if (self.orderInfo.email.indexOf("@") === -1 && this.email2 === "") {
					self.swalUtils.gritter('결제자 정보를 입력해 주세요.', "", "info", 1000)
				} else {

					if (self.infoMsg === '<p class="information" style="color: #ea5555;">올바른 번호가 아닙니다.</p>') {
						self.swalUtils.gritter('올바른 정보를 입력해 주세요.', "", "info", 1000)
					} else {

						//console.log('purchase self.orderInfo.oid',self.orderInfo.oid)
						self.axiosCaller.post(self, this.APIs.SHOP_ORDER + "/setOrder", {
							orderInfo: self.orderInfo,
							cidxs: self.$route.query.cidxs,
							gidx: self.$route.query.gidx,
							count: self.$route.query.count,
						}, (res) => {
							var result = res.data
							if (result.status === "ok") {

								console.log("isMobileYn", self.isMobileYn())

								if (self.isMobileYn()) {
									// mobile
									self.pay();
								} else {
									// pc browser
									window.INIStdPay.pay('SendPayForm_id');
								}

								// location.href = "/app/shop/order_info/order_done?oid=" + this.orderInfo.oid
							} else {
								self.swalUtils.gritter("Error", result.msg, "error")
										.then(() => {
											location.href = document.referrer
										})
							}
						});
					}

				}
			}
		},
		getPgInfo() {
			var self = this;

			this.axiosCaller.get(this, this.APIs.SHOP_PG + "/getIniInfo", {
				totalPrice: this.totalCost
				// totalPrice : '100'
			}, (res) => {
				var result = res.data
				if (result.status === "ok") {
					this.pg = result.pg;
					self.orderInfo.oid = self.pg.oid
					//console.log('pginfo self.orderInfo.oid',self.orderInfo.oid)

					//console.log('===pg====', this.pg)
				} else {
					this.swalUtils.gritter("Error", result.msg, "error")
							.then(() => {
								location.href = document.referrer
							})
				}
			});
		},
		/* 주소 찾기 */
		postCode() {
			var orderInfo = this.orderInfo
			new daum.Postcode({
				oncomplete: function (data) {

					var roadAddr = data.roadAddress; // 도로명 주소 변수
					var jibunAddr = data.jibunAddress; // 지번 주소 변수

					// 우편번호와 주소 정보를 해당 필드에 입력.
					console.log(data.zonecode)
					orderInfo.deliveryZipcode = data.zonecode;
					if (roadAddr !== '') {
						console.log(roadAddr)
						orderInfo.deliveryAddress1 = roadAddr;
					} else if (jibunAddr !== '') {
						console.log(jibunAddr)
						orderInfo.deliveryAddress1 = jibunAddr;
					}
				}
			}).open();

			const url = "/postCode"
			var param = {
				"isCloseBTN": "Y",
				"url": this.APIs.BASE_URL + url,
				noWEB: true,
				noANDROID: true,
			};
			this.appOpen(param)
		},
		changePaymnt() {
			switch (this.orderInfo.paidType) {
				case "B":
					this.pg.payment = "DirectBank";
					break;
				case "C":
					this.pg.payment = "Card";
					break;
				case "D":
					this.pg.payment = "VBank";
					break;
				default:
					this.pg.payment = "Card";
					break;
			}
		},
		// 이메일 input(email id 영역) 태그 내 "a @ b" 형식 입력 시 이메일 select(email domain) 태그 "직접입력"으로 자동 변경
		checkEmail() {
			if (this.email1.indexOf("@") !== -1) {
				$('#email2').val('');
				$('#email2').prop("disabled", true);
			} else {
				$('#email2').prop("disabled", false)
			}
		},
		checkPhone() {
			var r = /^0([0-9]{2,3})-?([0-9]{3,4})-?([0-9]{4,5})$/;
			if (!r.test(this.orderInfo.deliveryReceiverPhone))
				this.infoMsg = '<p class="information" style="color: #ea5555;">올바른 번호가 아닙니다.</p>'
			else
				this.infoMsg = '<p class="information">예시) 01012345678</p>'
		},
		setZipCodeAndAddress4IOS() {
			this.orderInfo.deliveryZipcode = document.querySelector('#zipcode').value
			this.orderInfo.deliveryAddress1 = document.querySelector('#address1').value
		},





	}
}
</script>
<style scoped>
.inforAgree {
	padding-left: 24px;
	margin-top: 8px;
	background-size: 16px;
	background-position: left 2px;
	font-size: 14px;
	line-height: 1.5;
	color: var(--gray-dark);
}

.inforAgreeBtn {
	padding-left: 10px;
	margin-top: 8px;
	background-size: 16px;
	background-position: left 2px;
	font-size: 14px;
	line-height: 1.5;
	color: var(--gray);
	text-decoration: underline;
}
</style>
